<template>
    <tab :index="tabIndex">
        <section class="section section--help">
            <b-container>
                <div v-if="getPathPromotion" class="saleoff-page">
                    <b-tabs>
                        <b-tab
                            :key="index"
                            v-for="(tab, index) in tabsPromotion"
                            @click.prevent="setActive(tab)"
                            :active="tab.id == currenttabsPromotion">
                            <template v-slot:title>
                                <div class="thumb">
                                    <img :src="getUrlStatic(tab.imgName)" alt="promotion">
                                </div>
                                <div class="content">{{ tab.name }}</div>
                            </template>
                            <transition name="fade">
                                <div class="reset-content">
                                    <!-- <slot name="content"></slot> -->
                                    <div v-if="posts[index]" v-html="posts[index].content"></div>
                                </div>
                            </transition>
                        </b-tab>
                    </b-tabs>
                </div>
                <div v-else class="help-page">
                    <b-card no-body>
                        <b-tabs
                            card
                            :ref="'tabContainer'"
                            :class="'tabContainer'"
                        >
                            <b-tab
                                :key="tab.slug"
                                v-for="tab in tabs"
                                @click="handleSwitchTab(tab)"
                                :active="tab.slug === getSlug ||
                                    (tab.slug === 'huong-dan' && helps.map(item => item.slug).includes(getSlug))"
                                :title="tab.name"
                            />
                            <transition name="fade">
                                <div  class="reset-content">
                                    <slot name="content"></slot>
                                    <b-row v-if="getPathHelp" class="wrap-guide">
                                        <b-col lg="6" md="6" sm="12" :key="i.slug" v-for="i in helps" class="col-menu">
                                            <n-link :to="`/${i.slug}`" class="item-guide effect-hover">
                                                <img :src="getUrlStatic(i.banner)" alt="hd">
                                            </n-link>
                                        </b-col>
                                    </b-row>
                                </div>
                            </transition>
                        </b-tabs>
                    </b-card>
                </div>
            </b-container>
        </section>
    </tab>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import tab from '~/components/tab.vue';

export default {
    components: { tab },
    props: {
        tabIndex: {
            type: String
        },
        posts: {
            type: Array
        }
    },
    created() {
        this.currenttabsPromotion = this.$getRoute(this.$route).query.type ? this.$getRoute(this.$route).query.type : this.tabsPromotion[0].id;
    },
    data() {
        return {
            tabs: [
                { name: 'về chúng tôi', slug: 'gioi-thieu' },
                { name: 'câu hỏi thường gặp', slug: 'nhung-cau-hoi-thuong-gap' },
                { name: 'chính sách bảo mật', slug: 'chinh-sach-bao-mat' },
                { name: 'điều khoản & điều kiện', slug: 'dieu-khoan-dieu-kien' },
                { name: 'hướng dẫn', slug: 'huong-dan' },
                { name: 'miễn trách nhiệm', slug: 'mien-trach-nhiem' }
            ],
            currenttabsPromotion: 'welcome',
            tabsPromotion: [
                {
                    id: 'welcome', name: 'thưởng nạp lần 1', slug: 'khuyen-mai', imgName: 'promotion-100ht1.jpg'
                },
                {
                    id: 'promotion', name: 'thưởng nạp lần 2', slug: 'khuyen-mai', imgName: 'promotion-30ht1.jpg'
                },
                {
                    id: 'commission', name: 'hoàn trả không giới hạn', slug: 'khuyen-mai', imgName: 'promotion-15ht1.jpg'
                }
                // {
                //     id: '300%', name: 'THƯỞNG NẠP 300%', slug: 'khuyen-mai', imgName: 'promotion-300ht1.jpg'
                // }
            ],
            helps: [
                { slug: 'huong-dan-dang-ky', banner: 'hd-dang-ky.jpg' },
                { slug: 'huong-dan-ca-cuoc', banner: 'hd-ca-cuoc.jpg' },
                { slug: 'huong-dan-nap-tien', banner: 'hd-nap-tien.jpg' },
                { slug: 'huong-dan-rut-tien', banner: 'hd-rut-tien.jpg' }
            ]
        };
    },
    computed: {
        getPathPromotion() {
            const { $route } = this;
            return $route.params.pathMatch === 'khuyen-mai';
        },
        getSlug() {
            const { $route } = this;
            return $route.params.pathMatch;
        },
        getPathHelp() {
            const { $route } = this;
            return $route.params.pathMatch === 'huong-dan';
        }
    },
    methods: {
        handleSwitchTab({ slug }) {
            const { $router } = this;
            return $router.push(`/${slug}`);
        },
        getUrlStatic(imgName) {
            const { $store: { state } } = this;
            return `${state.mapDomain.STATIC_URL}/assets/img/banner/${imgName}`;
        },
        setScrollTab() {
            // only mobile
            if (this.$isDesktop()) {
                return;
            }
            const itemIndex = Object(this.tabs)
                .findIndex((e) => e.slug === this.$getRoute(this.$route).params.pathMatch
                    || (e.slug === 'huong-dan' && this.helps.map(item => item.slug)
                        .includes(this.$getRoute(this.$route).params.pathMatch)));
            const tabWidth = this.$refs.tabContainer.$refs.nav.offsetWidth;
            const wrapTabWidth = this.$refs.tabContainer.$refs.tabsContainer.offsetWidth;
            if (tabWidth <= wrapTabWidth) {
                return;
            }
            const centerPoint = wrapTabWidth / 2;
            const currentTabEle = this.$refs.tabContainer.$refs.nav.children[itemIndex];
            const currentCenterPoint = currentTabEle.offsetLeft + currentTabEle.offsetWidth / 2;

            let scrollLeft = 0;
            if (currentCenterPoint > centerPoint) {
                scrollLeft = centerPoint - currentCenterPoint;
            }
            if (tabWidth - currentCenterPoint < centerPoint) {
                scrollLeft = -tabWidth + wrapTabWidth;
            }
            if (currentCenterPoint < centerPoint) {
                scrollLeft = 0;
            }
            // eslint-disable-next-line no-undef
            // eslint-disable-next-line object-shorthand
            $('.tabContainer > .card-header').animate({ scrollLeft: -scrollLeft }, 200);
        },
        setActive(tab) {
            this.$router.push({ path: this.$getRoute(this.$route).path, query: { type: tab.id } });
            this.activeTab = tab;
        }
    },
    watch: {
        getSlug(value) {
            this.activeTab = value;
            this.setScrollTab();
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.getPathPromotion) return;
            setTimeout(() => {
                this.setScrollTab();
            }, 100);
        });
        window.addEventListener('resize', this.setScrollTab);
    }
};
</script>
<style lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
